import gql from 'graphql-tag';

export interface SlackWorkspace {
  name: string;
  teamId: string;
}

export const COMPANY_SLACK_WORKSPACES_FROM_DB = gql`
  query GetCompanySlackWorkspaces {
    companySlackWorkspacesFromDb {
      workspaces {
        name
        teamId
      }
      isEnterpriseInstall
    }
  }
`;
